import React from "react";

/**
 * Header is retired — BrandMark (top-left) and TopMenu (top-right) provide
 * a consistent, aligned top chrome across every consumer screen. Pages now
 * own their own top padding via safe-area + the floating chip baseline.
 *
 * This stub returns null so existing imports keep working while the legacy
 * Header markup is removed from the layout. Safe to delete the file once
 * `App.js` stops mounting it.
 */
export default function Header() {
  return null;
}
